import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { rootKeys } from '../cache-keys/rootKeys';
import { userKeys } from '../cache-keys/userKeys';
import { loan_application } from '@axo/shared/data-access/types';
import { loan_application_api } from '@axo/shared/data-access/api';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { assignmentKeys } from '../cache-keys/assignmentKeys';
import { applicationAssignmentKeys } from '../cache-keys/applicationAssignmentKeys';

interface ICloneApplication {
  loanApplicationID: string;
  data: Partial<loan_application.LoanApplication>;
}

export function useCloneApplication() {
  const {
    state: {
      user: { email },
    },
  } = useContext(DataAccessContext);
  const client = useQueryClient();
  const api = useAPI();

  return useMutation(
    ({ loanApplicationID, data }: ICloneApplication) =>
      loan_application_api.cloneLoanApplication(api)(loanApplicationID, data),
    {
      onSuccess: (result, { loanApplicationID }) => {
        client.invalidateQueries(
          applicationAssignmentKeys.root({
            applicationID: loanApplicationID,
            marketCountry: result.MarketCountry,
          })
        );
        client.invalidateQueries(rootKeys.searchIndex());
        client.invalidateQueries(
          assignmentKeys.root({
            marketCountry: result.MarketCountry,
          })
        );
        client.invalidateQueries(
          userKeys.assignedApplications({
            user: email,
            country: result.MarketCountry,
          })
        );
      },
    }
  );
}
